// Simple Mobile Utilities
// Basic mobile optimization functions

/**
 * Prevents zoom on input focus for iOS devices
 */
export const preventZoomOnFocus = (event) => {
  if (window.innerWidth <= 768) {
    event.target.style.fontSize = '16px';
  }
};

/**
 * Simple mobile scroll to element
 */
export const scrollToElement = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

/**
 * Check if device is mobile
 */
export const isMobile = () => {
  return window.innerWidth <= 768;
};

/**
 * Force scroll to top of page
 * This function ensures the page scrolls to top regardless of browser differences
 */
export const scrollToTop = () => {
  // Try multiple methods for maximum compatibility
  try {
    // Method 1: window.scrollTo with instant behavior
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  } catch (e) {
    // Fallback for browsers that don't support instant behavior
    try {
      window.scrollTo(0, 0);
    } catch (e2) {
      // Final fallback
      window.scrollTo(0, 0);
    }
  }
  
  // Also try scrolling document elements directly
  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }
  if (document.body) {
    document.body.scrollTop = 0;
  }
  
  // Force scroll position for stubborn browsers
  setTimeout(() => {
    window.scrollTo(0, 0);
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }, 50);
};

/**
 * Check if device supports touch
 */
export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

/**
 * Disable all animations on mobile for static behavior
 */
export const disableMobileAnimations = () => {
  if (isMobile()) {
    // Disable CSS animations
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 768px) {
        *, *::before, *::after {
          animation: none !important;
          transition: none !important;
          transform: none !important;
        }
        .floating-element { display: none !important; }
        .animate-fade-in-up,
        .animate-fade-in-left,
        .animate-fade-in-right,
        .animate-slide-in-up {
          animation: none !important;
          opacity: 1 !important;
          transform: none !important;
        }
      }
    `;
    document.head.appendChild(style);
    
    // Disable Framer Motion animations
    const motionElements = document.querySelectorAll('[data-framer-motion]');
    motionElements.forEach(el => {
      el.style.animation = 'none';
      el.style.transition = 'none';
      el.style.transform = 'none';
    });
  }
};

const mobileUtils = {
  preventZoomOnFocus,
  scrollToElement,
  isMobile,
  isTouchDevice,
  disableMobileAnimations
};

export default mobileUtils;
